/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import ManageDeviceTemplateTable from "./Components/Table"
import ManageDeviceTemplateTopBar from "./Components/Topbar"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { handleIsAPICall } from "../../redux/commonSlice"
import { useDeleteDeviceTemplateMutation, useExportDeviceTemplatesMutation, useGetDeviceTemplatesQuery } from "../../features/deviceTemplateSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { handleAddFilterValues, handleSidebarPrvState } from "../../redux/systemConfigSlice"
import DeviceTemplateSearch from "./Components/AdvancedSearch"
import { resetDeviceTemplateSearch, setDeviceTempSearchApplied } from "../../redux/deviceTemplateSearchSlice"


export default function ManageDeviceTemplates() {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar, setIsSideBar, isAdvancedSearchOpen, setIsAdvancedSearchOpen } = useContext(GlobalContext);

    // const [editProvider] = useEditProviderMutation()
    const [exportDeviceTemplate] = useExportDeviceTemplatesMutation()
    const [deleteDeviceTemplates] = useDeleteDeviceTemplateMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [selectedRow, setSelectedRow] = useState([])
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const [dateFilled,setdateFilled] = useState(false);
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const [filterValues, setFilterValues] = useState({});
    const [multiDelete, setMultiDelete] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const deviceTemplateSearch = useSelector(state => state.deviceTemplateSearchData); // Select deviceTemplateSearch from Redux
    const searchApplied = useSelector((state) => state.deviceTemplateSearchData.devicetempsearchApplied);




    const { data, isFetching, isLoading, status } = useGetDeviceTemplatesQuery(searchParams?.toString(), { skip: skip || location.search === '' })
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        // Ensure page_number is a valid number if being set
        if (key === 'page_number' && (isNaN(value) || value < 1)) {
            params[key] = 1
        } else if (key === 'search') { 
            params[key] = encodeURIComponent(value); 
        } else {
            params[key] = value
        }
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }

    /* The above code is a useEffect hook in a React component. It is used to handle the side effects when
    the `location` object changes. */
    useEffect(() => {
        if (location.search === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            let params = { limit: '15', page_number: '1', ...location.state };
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        }
        else {
            const params = Object.fromEntries(searchParams)
            let changed = false
            if (!params.limit) { params.limit = '15'; changed = true }
            if (!params.page_number) { params.page_number = '1'; changed = true }
            if (changed) setSearchParams(params, { replace: true })
        }
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
    }, [location]);

    /* The above code is using the useEffect hook in React to check the size of the searchParams
    object. If the size is greater than or equal to 2, it sets the value of the skip state variable
    to false. Otherwise, it sets the value of the skip state variable to true. The useEffect hook is
    triggered whenever the searchParams object changes. */
    useEffect(() => {
        if (searchParams.size >= 2) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])


    /**
    * The function `handleNoOfRowsClick` updates the search parameters by setting the page number to 1
    * and the limit to the specified number.
    */
    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }

    /**
    * The function `handleOnClickPageNumber` updates the search parameters with a new page number and
    * sets the `isSortSelected` state to false.
    */
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };



    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleDelete = async (e) => {
        setLoading(true)
        let body = {
            template_id: [selectedRow.template_id]
        }
        const res = await deleteDeviceTemplates(body)
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message)
            setLoading(false)
        }
        else {
            setToastmessage('Device profile deleted successfully');
            setLoading(false)
            handleConformationClick()
        }
    }

    const totalPageNumber=Math.ceil(parseInt(data?.total_count) / parseInt(limit))

    /**
    * The function `handleMultiRowDelete` deletes multiple device templates and displays a success
    * message or an error message if the deletion fails.
    */
    const handleMultiRowDelete = async () => {
        setLoading(true)
        setMultiDelete(true);
        let body = {
            template_id: selectedRows.map(item => item.id)
        }
        const res = await deleteDeviceTemplates(body)
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message)
            setIsChangeStatusOpen(false)
            setDeleteLoading(false)
        }
        else {
            if (parseInt(searchParams.get('page_number')) === totalPageNumber) {
                // Increment the page_number by 1
                const updatedPageNumber = parseInt(searchParams.get('page_number')) - 1;
                // Update the page_number in the URLSearchParams
                searchParams.set('page_number', updatedPageNumber);
                // Call your listing API with the updated parameters
                setSearchParams({ ...searchParams });
            }
            setToastmessage('Device profile deleted successfully');
            setLoading(false)
            setMultiDelete(false);
            setIsChangeStatusOpen(false)
        }
        dispatch(resetArrays());
    }

    const handleDeleteModelClose = () => {
        setMultiDelete(false);
    }

    const handleOnSubmit = (e) => {  
        e.preventDefault();  
        let searchString = '';
    
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `template_id` and `template_id_inverse` conditions
        if (deviceTemplateSearch?.template_id && deviceTemplateSearch?.template_id.trim()!=='') {
            const temlateIdPrefix = deviceTemplateSearch.template_id_inverse ? 'ne:' : '';
            const formattedTemplateId = formatSearchValue(deviceTemplateSearch.template_id);
            searchString += `template_id=${temlateIdPrefix}${encodeURIComponent(formattedTemplateId)};`;
        }

        // Check for `manufacturer` and `manufactrer_inverse` conditions
        if (deviceTemplateSearch?.template_name && deviceTemplateSearch?.template_name.trim()!=='') {
            const templateNamePrefix = deviceTemplateSearch.template_name_inverse ? 'ne:' : '';
            const formattedTemplateName = formatSearchValue(deviceTemplateSearch.template_name);
            searchString += `template_name=${templateNamePrefix}${encodeURIComponent(formattedTemplateName)};`;
        }

        // Check for `model` and `model_inverse` conditions
        if (deviceTemplateSearch?.model && deviceTemplateSearch?.model.trim()!=='') {
            const modelPrefix = deviceTemplateSearch.model_inverse ? 'ne:' : '';
            const formattedmodel = formatSearchValue(deviceTemplateSearch.model);
            searchString += `model=${modelPrefix}${encodeURIComponent(formattedmodel)};`;
        }
        if (deviceTemplateSearch?.manufacturer_name && deviceTemplateSearch?.manufacturer_name.trim()!=='') {
            const serialNumberPrefix = deviceTemplateSearch.manufacturer_name_inverse ? 'ne:' : '';
            const formattedSerialNumber = formatSearchValue(deviceTemplateSearch.manufacturer_name);
            searchString += `manufacturer_name=${serialNumberPrefix}${encodeURIComponent(formattedSerialNumber)};`;
        }
        if (deviceTemplateSearch?.template_creator && deviceTemplateSearch?.template_creator.trim()!=='') {
            const templateCreatorPrefix = deviceTemplateSearch.template_creator_inverse ? 'ne:' : '';
            const formattedtemplteCreator = formatSearchValue(deviceTemplateSearch.template_creator);
            searchString += `template_creator=${templateCreatorPrefix}${encodeURIComponent(formattedtemplteCreator)};`;
        }

        const { created_day, created_month, created_year} = deviceTemplateSearch || {};
        // Check if only some of the fields are filled
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));
        // Check for incomplete length in created date fields
        if (
            (created_day && created_day.length < 2) ||
            (created_month && created_month.length < 2) ||
            (created_year && created_year.length < 4)
        ) {
            setdateFilled(true);
            return;
        }

        

        if (isPartialDateFilled) {
            setdateFilled(true) 
            return;       
        } else if (created_day && created_month && created_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00) UTC
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds (UTC)
            const epochDate = Math.floor(date.getTime() / 1000);
            const createdDatePrefix = deviceTemplateSearch.created_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `created_at=${createdDatePrefix}${epochDate};`;
        }        

        const { updated_day, updated_month, updated_year} = deviceTemplateSearch || {};
        // Check if only some of the fields are filled
        const isPartiallDateFilled = (updated_day && (!updated_month || !updated_year)) || (updated_month && (!updated_day || !updated_year)) || (updated_year && (!updated_day || !updated_month));

        // Repeat similarly for updated date fields
        if (
            (updated_day && updated_day.length < 2) ||
            (updated_month && updated_month.length < 2) ||
            (updated_year && updated_year.length < 4)
        ) {
            setdateFilled(true);
            return;
        }
        if (isPartiallDateFilled) {
            setdateFilled(true) 
            return;       
        } else if (updated_day && updated_month && updated_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${updated_year}-${String(updated_month).padStart(2, '0')}-${String(updated_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00) UTC
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds (UTC)
            const epochDate = Math.floor(date.getTime() / 1000);
            const updatedDatePrefix = deviceTemplateSearch.updated_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `updated_at=${updatedDatePrefix}${epochDate};`;
        }        
        

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceTemplateSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setDeviceTempSearchApplied());
    };
    

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetDeviceTemplateSearch());
        }
    }, [dispatch, searchApplied]);


    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Device Templates"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <ManageDeviceTemplateTopBar
                            title={'List of Device Templates'}
                            path={'/manage-device-templates/add-device-template'}
                            AddButton={true}
                            buttonName={"Create Device Template"}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            menuBar={(data !== undefined && data?.data?.length>0&&selectedRows?.length > 0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['Template ID', 'Template Name', 'Manufacturer', 'Model', 'Template Creator', 'Creation Timestamp', 'Modified Timestamp']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportDeviceTemplate={exportDeviceTemplate}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleMultiRowDelete={handleMultiRowDelete}
                            setMultiDelete={setMultiDelete}
                            setIsChangeStatusOpen={setIsChangeStatusOpen}
                            isChangeStatusOPen={isChangeStatusOPen}
                            totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(limit))}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected" && !isSortselected) || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Device Templates..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <ManageDeviceTemplateTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                setSelectedRow={setSelectedRow}

                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                            <p className="text-sm font-semibold text-[#687182]" id="total_records">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {/* {data?.total_count === 0 || (data?.success_status === "false") ?
                            <Emptyscreen
                                title={"Manage Device Profile"}
                                FirstPTag={"No Device template created yet."}
                                SecondePTag={"Start managing by clicking 'Create Device Template'"}
                            /> 
                            : status === "rejected" && 
                                <SearchEmptyScreen text={"No data found"} />
                        } */}

                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")  ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            
                               
                            :(data?.total_count===0 && !searchParams.get("search")&&(!searchParams.get("filter")))?
                                <Emptyscreen title={"Manage Device Profile"} 
                                    FirstPTag={"No Device template created yet."}
                                    SecondePTag={"Start managing by clicking 'Create Device Template'"}
                                />
                                :
                                ((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleDelete}
                                handleClose={handleConformationClick}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete this device template?`}
                                buttonName={"Yes"}
                               
                                loadingActivation={loading}
                                CancelButton={"No"}
                            />
                        }
                    />
                }
                {multiDelete &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleMultiRowDelete}
                                handleClose={handleDeleteModelClose}
                                tittle={'Delete'}
                                userList={selectedRows.map(item =>item.id)}
                                message={`Are you sure you want to delete the selected device templates?`}
                                buttonName={"Yes"}
                                loadingActivation={loading}
                                CancelButton={"No"}
                            />
                        }
                    />
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <DeviceTemplateSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={dateFilled}
                    setEmptyField={setdateFilled}
                />
                }
            </div>
        </>

    )
}
